<p class="ln-own">{{ notice.ownership }}</p>
<p class="ln-p">{{ notice.policiesIntro }}</p>

<!-- one row per required policy; tap to read it -->
<div class="ln-list">
  <div class="ln-item" *ngFor="let pol of policies()" [class.on]="openKey() === pol.key">
    <button type="button" class="ln-item-head" (click)="toggle(pol.key)"
            [attr.aria-expanded]="openKey() === pol.key">
      <span class="ln-item-txt">
        <span class="ln-item-title">{{ pol.title }}</span>
        <span class="ln-item-sub">{{ pol.sub }}</span>
      </span>
      <svg class="ln-chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M6 9l6 6 6-6"/></svg>
    </button>

    <!-- the policy itself: clause headings, paragraphs, lettered clauses and rate tables -->
    <div class="ln-item-body" *ngIf="openKey() === pol.key">
      <!-- @if narrows the LegalBlock union on `k`; *ngSwitch does not, so the tier/li
           properties would not type-check under one. -->
      @for (b of pol.blocks; track $index) {
        @if (b.k === 'h') {
          <h3 class="ln-h">{{ b.t }}</h3>
        } @else if (b.k === 'p') {
          <p class="ln-p" [class.tight]="b.tight">{{ b.t }}</p>
        } @else if (b.k === 'li') {
          <div class="ln-li">
            <span class="ln-mark" [class.dot]="!b.m">{{ b.m }}</span>
            <span>{{ b.t }}</span>
          </div>
        } @else {
          <div class="ln-tier">
            <div class="ln-tier-h">{{ b.t }}</div>
            @for (r of b.rows; track $index) {
              <div class="ln-tier-row">
                <span class="ln-tier-k">{{ r[0] }}</span>
                <span class="ln-tier-v">{{ r[1] }}</span>
              </div>
            }
          </div>
        }
      }
    </div>
  </div>
</div>

<!-- company block: the registered name and how to reach us -->
<div class="ln-card">
  <div class="ln-card-h">{{ company.legalName }}</div>
  <div class="ln-card-l" *ngIf="company.ssm">SSM: {{ company.ssm }}</div>
  <div class="ln-card-l" *ngFor="let l of company.addressLines">{{ l }}</div>
  <div class="ln-card-links">
    <a [href]="'mailto:' + company.email">{{ company.email }}</a>
    <a [href]="'tel:+' + company.phoneDigits">{{ company.phone }}</a>
  </div>
</div>
